import type { UntitledIconData } from '../../UntitledIconData'

const ulFileShield03: UntitledIconData = {
  prefix: 'ul',
  name: 'file-shield-03',
  paths: [
    {
      shape:
        'M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8M14 2L20 8M14 2V8H20M12 18C12 18 15 16.5701 15 14.4252V11.9229L12.8124 11.1412C12.2868 10.9529 11.712 10.9529 11.1864 11.1412L9 11.9229V14.4252C9 16.5701 12 18 12 18Z',
    },
  ],
}

export default ulFileShield03
